import React from 'react';

export const CrossButtonIcon = ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L17 17M1 17L17 1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
